import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { RamRolesOptions } from '@enums/user-role.enum';

@Component({
  selector: 'app-user-ram-role-selection',
  templateUrl: './user-ram-role-selection.component.html',
  styleUrls: ['./user-ram-role-selection.component.scss'],
})
export class UserRamRoleSelectionComponent implements OnInit {
  ramRolesOptions: string[];
  securityRolesForm: UntypedFormGroup;
  selectedRoles: string[];

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<UserRamRoleSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public userRamRoles: any
  ) {
    this.ramRolesOptions = RamRolesOptions.getAllTextValues().filter((role) => role.startsWith('TST'));
    this.selectedRoles =
      this.userRamRoles?.ramRoles?.filter((role) => role.startsWith('TST') && this.ramRolesOptions.includes(role)) ||
      [];
  }

  ngOnInit(): void {
    this.ramRolesOptions = RamRolesOptions.getAllTextValues().filter((role) => role.startsWith('TST'));

    const selectedRoles =
      this.userRamRoles?.ramRoles?.filter((role) => role.startsWith('TST') && this.ramRolesOptions.includes(role)) ||
      [];
    this.selectedRoles = selectedRoles;
    this.securityRolesForm = this.fb.group({
      selectedRamRoles: this.fb.array(this.ramRolesOptions.map((role) => selectedRoles.includes(role))),
    });
  }

  close() {
    this.dialogRef.close(this.selectedRoles);
  }

  get selectedRamRolesArray(): UntypedFormArray {
    return this.securityRolesForm.get('selectedRamRoles') as UntypedFormArray;
  }

  ramRolesSelection(): void {
    const selected = this.securityRolesForm.value.selectedRamRoles
      .map((checked: boolean, i: number) => (checked ? this.ramRolesOptions[i] : null))
      .filter((role) => role !== null);
    this.selectedRoles = selected;
    this.close();
  }

  isAllSelected(): boolean {
    return this.selectedRamRolesArray.controls.every((control) => control.value === true);
  }

  toggleSelectAll(checked: boolean): void {
    this.selectedRamRolesArray.controls.forEach((control) => control.setValue(checked));
  }
}
